export interface ActivityCategory {
  id: string;
  name: string;
  icon: string;
  enabled: boolean;
  description?: string;
}

const listeners = new Set<() => void>();

const _categories: ActivityCategory[] = [];

function notify(): void {
  listeners.forEach((fn) => fn());
}

export const activityCategoryStore = {
  getAll: (): ActivityCategory[] => [..._categories],

  getEnabled: (): ActivityCategory[] => _categories.filter((c) => c.enabled),

  add: (item: ActivityCategory) => {
    _categories.push(item);
    notify();
  },

  update: (id: string, changes: Partial<ActivityCategory>) => {
    const idx = _categories.findIndex((c) => c.id === id);
    if (idx !== -1) Object.assign(_categories[idx], changes);
    notify();
  },

  remove: (id: string) => {
    const idx = _categories.findIndex((c) => c.id === id);
    if (idx !== -1) _categories.splice(idx, 1);
    notify();
  },

  toggleEnabled: (id: string) => {
    const item = _categories.find((c) => c.id === id);
    if (item) item.enabled = !item.enabled;
    notify();
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  replaceFromApi(items: ActivityCategory[]): void {
    _categories.length = 0;
    for (const c of items) {
      _categories.push({
        ...c,
        enabled: c.enabled !== false,
        description: c.description ?? "",
      });
    }
    notify();
  },
};
